import { useEffect, useState } from "react";
import NewClientAddressModal from "./NewClientAddressModal";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import {
  deleteClientAddress,
  getClientAddressDetails,
  selectClientAddressDetails,
  selectLoadingClientAddressDetails,
  updateClientAddressDetails,
} from "./ClientAddressesSlice";
import { useSelector } from "react-redux";
import { selectClientID } from "../ContactDetailsSlice";
import { ClientAddressModel } from "services/api/cplapi/CPLAPI";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import ClientAddressDetails from "./ClientAddressDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { selectGlobalSettings } from "app/modules/system/settings/ClientPortalSettingsSlice";

const ClientAddressesList = () => {
  const clientID = useSelector(selectClientID);
  const loading = useSelector(selectLoadingClientAddressDetails);
  const clientAddresses = useSelector(selectClientAddressDetails);
  const { showEmailAddressEdit } = useSelector(selectGlobalSettings);
  const canEdit = showEmailAddressEdit !== false;
  const [showNewAddressModal, setShowNewAddressModal] = useState(false);
  const thunkDispatch = useThunkDispatch();

  useEffect(() => {
    thunkDispatch(getClientAddressDetails({ clientID: clientID }));
  }, [thunkDispatch, clientID]);

  function updateAddressDetails(newClientAddressDetails: ClientAddressModel) {
    thunkDispatch(updateClientAddressDetails({ clientAddressModel: newClientAddressDetails }));
  }

  function deleteAddress(clientAddressID: string) {
    thunkDispatch(deleteClientAddress({ clientAddressID: clientAddressID }));
  }

  return (
    <>
      <NewClientAddressModal
        ShowNewAddressModal={showNewAddressModal}
        DismissNewAddressModalCallback={() => setShowNewAddressModal(false)}
      />
      <div className="card">
        <div className="card-body">
          <div className="row mb-2">
            <div className="col-sm-8 col-md-9">
              <h2 className="heading-text">Addresses</h2>
            </div>
            <div className="col-sm-4 col-md-3 text-end">
              {canEdit && (
                <button
                  data-test-id="addresses-list__new-address-button"
                  className="cpl-btn btn-icon cpl-btn-primary"
                  onClick={() => setShowNewAddressModal(true)}
                >
                  <span className="page-create-btn">
                    <FontAwesomeIcon icon={faPlus} className="pt-1" />
                  </span>
                  <span className="ms-2">New Address</span>
                </button>
              )}
            </div>
          </div>
          <ActivityIndicator isBusy={loading}>
            {clientAddresses?.map((clientAddress) => {
              return (
                <div key={clientAddress.clientAddressID} className="border-top pb-2">
                  <ClientAddressDetails
                    ClientAddressDetails={clientAddress}
                    UpdateClientAddressDetailsCallback={updateAddressDetails}
                    DeleteClientAddressDetailsCallback={deleteAddress}
                  />
                </div>
              );
            })}
          </ActivityIndicator>
        </div>
      </div>
    </>
  );
};

export default ClientAddressesList;
